import { HTMLAttributes, ReactNode } from 'react';

export const Card = ({
  className = '',
  children,
  ...rest
}: HTMLAttributes<HTMLDivElement>) => (
  <div className={`card ${className}`.trim()} {...rest}>
    {children}
  </div>
);

interface CardHeadProps {
  title: ReactNode;
  sub?: ReactNode;
  action?: ReactNode;
}

export const CardHead = ({ title, sub, action }: CardHeadProps) => (
  <div className="card-head">
    <div>
      <div className="card-title">{title}</div>
      {sub && <div className="card-sub">{sub}</div>}
    </div>
    {action}
  </div>
);

export default Card;
